module.exports = __webpack_public_path__ + "static/media/8.496d8bbc.jpeg";